module.exports = __webpack_public_path__ + "img/bc-brutkar.7d17cd57.png";